import React from "react";
import Icon from '@ant-design/icons';
import { ReactComponent as MessageSvg } from './ReportingSVG.svg';

const IconReporting = (props) => {
  return (<Icon component={MessageSvg} {...props} />);
}

export default IconReporting;